<p class="text-primary-700 dark:text-primary-400">&copy; {{copyrightYears}} &mdash; {{copyrightHolder}} v{{version}}</p>